import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Autorenew from '@material-ui/icons/Autorenew';
import React from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import PrestadorService from '../../services/PrestadorService';
import Utils from '../share/Utils';
import LongMenu from '../share/LongMenu';
import { Fade, Avatar } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import VariantSnackbar from '../share/VariantSnackbar';
import AlertDialogSlide from '../share/AlertDialogSlide';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    marginLeft: '20px'
  },
  tableRowCredenciado: {
    backgroundColor: 'rgb(223, 240, 216)',
  },
});
class PrestadorOrgaoExterno extends React.Component {
  prestadorService = new PrestadorService();
  utils = new Utils();
  state = {
    prestadores: [],
    fetching: false,
    anchorEl: null,
    prestadorSelecionado: {},
    openDialog: false,
    modoInclusao: true,
    isEditavel: true,
    tituloFormDialog: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    snackSucesso: true,
    dialogTitle: '',
    dialogContent: '',
    dialogMessage: 'Deseja vincular este prestador a um Órgão Externo?',
  }

  componentDidMount = async () => {    
    await this.consultarPrestadores();
  }

  consultarPrestadores = async () => {
    this.setState({fetching: true});    
    const prestadores = await this.prestadorService.consultarPrestadoresSemOrgaoExterno();
    this.setState({prestadores: prestadores, fetching: false});
  }

  handleClickMenu = (event, tableMeta) => {
    const prestadorSelecionado = {
      codPrestador: this.state.prestadores[tableMeta.rowIndex][0],
      nomPrestador: this.state.prestadores[tableMeta.rowIndex][1],
    };
    this.setState({ anchorEl: event.currentTarget, prestadorSelecionado: prestadorSelecionado });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }

  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    this.setState({openDialog: true, tituloFormDialog: 'Vincular Órgão Externo - ' + this.state.prestadorSelecionado.nomPrestador, modoInclusao: false, isEditavel: true});
  }

  vincularPrestadorOrgaoExterno = async () => {
    this.setState({fetching: true});
    let nomPrestador = this.state.prestadorSelecionado.nomPrestador.replace('/', '|');
    let result = await this.prestadorService.vincularPrestadorOrgaoExterno(this.state.prestadorSelecionado.codPrestador, nomPrestador);
    await this.onOperacaoFinalizada(result);
  }

  onOperacaoFinalizada = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível realizar a operação. Este prestador pode estar credenciado, ou possui endereços e telefones...', fetching: false, snackSucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({snackOpen: true, snackMessage: result.data.msgRetornoResumida, fetching: false, snackSucesso: true});
      } else {
        this.setState({dialogErrosOpen: true, dialogContent: result.data.registrosComErros, dialogTitle: result.data.msgRetornoResumida, fetching: false, snackSucesso: false});
      }
    }
    this.setState({prestadorSelecionado: {}});
    await this.consultarPrestadores();
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };
  handleDialogConfirm = async () => {
    this.setState({ openDialog: false });
    await this.vincularPrestadorOrgaoExterno();
  }

  render () {
    const options = {
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>prestador(es) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Código',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'CPF/CNPJ',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return (
              <Typography>{this.utils.cpfOuCnpj(value)}</Typography>
            );
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <Autorenew />,
                primaryText: 'Vincular Órgão Ext.',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
    ];

    const { classes } = this.props;
    const { fetching, prestadores } = this.state;
    return (
      <React.Fragment>
        <Link to='/prestador' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Prestadores Sem Vinculação a Órgão Externo</Typography>
              {prestadores && <Avatar className={classes.avatar}>{prestadores.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={prestadores}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          duration={3000}
          handleClose={this.handleCloseSnackbar} />
        <AlertDialogSlide
          open={this.state.openDialog}
          handleClose={this.handleCloseDialog}
          handleClick={this.handleDialogConfirm}
          title={this.state.tituloFormDialog}
          message={this.state.dialogMessage} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PrestadorOrgaoExterno);
